import React, { Component, Suspense, lazy } from "react";
import {
  BrowserRouter,
  Switch,
  Route,
  Link,
  HashRouter,
  IndexRoute,
  Redirect,
} from "react-router-dom";

import { Header, Sidebar } from "../views/elements";
import { Api } from "../utils/Variables";
import API from "../utils/API";
import Cookies from "universal-cookie";
import routes from "../views";
import { setCookie, removeBothSlash } from "../utils";

class SiteLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    //this.loadSiteinfo();
  }

  loadSiteinfo() {
    try {
      API.get("v1/settings/me/1").then((res) => {
        if (res["data"].status == "1") {
          setCookie("site", JSON.stringify(res["data"].data));
        }
      });
    } catch (error) {
      console.log(error);
    }
  }

  getType() {
    try {
      var path = window.location.pathname;

      var paths = removeBothSlash(path).trim().split("/");
      //return paths[1];
      let p = paths[1] == undefined ? "qnm" : paths[1];
      return p == "qnm" || p == "qlm" ? p : false;
    } catch (error) {
      return false;
    }
  }

  render() {
    const TYPE = this.getType();
    console.log(TYPE);
    const CLASS_NAME = "ssr_" + (TYPE || "qnm");

    return (
      <div className={CLASS_NAME}>
        <Header routes={routes} type={TYPE} />

        <div className="container-fluid">
          <div className="row">
            <Sidebar type={TYPE} />

            <main
              role="main"
              className="col-md-9 ml-sm-auto col-lg-9 pt-3 px-4"
            >
              <Switch>
                {routes.map((page, key) => (
                  <Route
                    exact
                    path={page.path}
                    component={page.component}
                    key={key}
                  />
                ))}
              </Switch>
            </main>
          </div>
        </div>
      </div>
    );
  }
}
export default SiteLayout;
